import { createReducer } from "@reduxjs/toolkit"
import {
    logout,
    setAuthUser,
    setDynamicAssetsData,
    setWebsites,
    setMfaRequired,
    setOtpToken,
    setOtpEmail,
} from "../actions"

const initialState = {
    isAuthenticated: false,
    user: {},
    websites: [],
    assets: [],
    isMfaRequired: JSON.parse(localStorage.getItem("isMfaRequired")) || false,
    otpToken: localStorage.getItem("otpToken") || "",
    otpEmail: localStorage.getItem("otpEmail") || "",
}

const AuthReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setAuthUser, (state, action) => {
            localStorage.setItem("user", JSON.stringify(action.payload))
            state.user = action.payload
            state.isAuthenticated = true
        })
        .addCase(setDynamicAssetsData, (state, action) => {
            state.assets = action.payload
        })
        .addCase(setWebsites, (state, action) => {
            localStorage.setItem("websites", JSON.stringify(action.payload))
            state.websites = action.payload
        })
        .addCase(setMfaRequired, (state, action) => {
            localStorage.setItem("isMfaRequired", JSON.stringify(action.payload))
            state.isMfaRequired = action.payload
        })
        .addCase(setOtpToken, (state, action) => {
            localStorage.setItem("otpToken", action.payload)
            state.otpToken = action.payload
        })
        .addCase(setOtpEmail, (state, action) => {
            localStorage.setItem("otpEmail", action.payload)
            state.otpEmail = action.payload
        })
        .addCase(logout, (state, action) => {
            localStorage.removeItem("isMfaRequired")
            localStorage.removeItem("otpToken")
            localStorage.setItem("otpEmail", action.payload)
            state.isAuthenticated = false
            state.user = {}
            state.isMfaRequired = false
            state.otpToken = ""
            state.otpEmail = ""
        })
        .addDefaultCase((state, action) => state)
})

export default AuthReducer
